import React from 'react';

const Loader = () => {
    return (
        <div>
            <span className="loading loading-infinity loading-lg"></span>

        </div>
    );
};

export default Loader;